import { useCallback, useState, useEffect } from 'react';
import { Option, UserEntityInterface } from '@types';
import { Avatar, TextField } from '@material-ui/core';
import { getAllUsers } from '@services/userService';
import { translate } from '@utils';
import Autocomplete from '@sharedComponents/Autocomplete';
import { environment } from '@env';
import isEmpty from 'lodash/isEmpty';

const renderInput = (params) => {
  return <TextField {...params} placeholder={translate('search')} />;
};
const url = `${environment.API_URL}public/image/`;

const renderOption = (option: Option<UserEntityInterface>) => {
  return (
    <div className="management-autocomplete-option" key={option.value.id}>
      <Avatar src={`${url}${option.value.id}`} className="management-autocomplete-option__avatar" />
      <span className="management-autocomplete-option__name">{option.label}</span>
      {isEmpty(option.value?.roles)
        ? option.value?.unit?.roles.map((role, id) => (
            <span key={id} className="management-autocomplete-option__role">
              {role.name}
            </span>
          ))
        : option.value?.roles.map((role, id) => (
            <span key={id} className="management-autocomplete-option__role">
              {role.name}
            </span>
          ))}
    </div>
  );
};

const getOptionDisabled = (option: Option<UserEntityInterface>) => {
  return !isEmpty(option?.value.roles) || option.disabled;
};

export const UsersSearch = ({ onChange, tableUsers }) => {
  const [options, setOptions] = useState<Option<UserEntityInterface>[]>([]);
  const [previewUsers, setPreviewUsers] = useState<UserEntityInterface[]>([]);

  useEffect(() => {
    setOptions(
      previewUsers.map((item) => {
        return {
          value: item,
          label: item['fullNameEng'],
          disabled: Boolean(tableUsers.find((user) => user.id === item.id)),
        };
      })
    );
  }, [previewUsers, tableUsers]);

  const onInputChange = useCallback(async (event, value) => {
    const { items } = await getAllUsers({ fullName: value, limit: 5 });
    setPreviewUsers(items);
  }, []);

  return (
    <Autocomplete
      options={options}
      renderInput={renderInput}
      onInputChange={onInputChange}
      onChange={onChange}
      renderOption={renderOption}
      getOptionDisabled={getOptionDisabled}
    />
  );
};
